import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
} from 'app/components/global';
import pandemicPlanProcedure from './pandemicPlanProcedure';
import editPandemicPlanProcedureDialog from './pandemicPlanProcedure/dialog.editPandemicPlanProcedureDialog';
import controller from './pandemic-plan.controller';
import directive from './pandemic-plan.directive';

export default angular.module('app.components.advisory.bcp.pandemicPlan', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
  pandemicPlanProcedure,
  editPandemicPlanProcedureDialog,
])
  .directive('bcpPandemicPlan', directive)
  .controller('PandemicPlanController', controller)
  .name;

console.log('app.components.advisory.bcp.pandemicPlan created');
